var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExposureModerate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-exposure-mod{fill:#7eac20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-mod",
    d: "M40.71,63.5h-10a1.5,1.5,0,0,0,0,3h10c0-.5-.05-1-.05-1.5S40.68,64,40.71,63.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-mod",
    d: "M100.75,63.5H89.29c0,.5,0,1,0,1.5s0,1,0,1.5h11.46a1.5,1.5,0,0,0,0-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-mod",
    d: "M47.13,81.5l-7.19,7.19a1.49,1.49,0,0,0,0,2.12,1.5,1.5,0,0,0,2.12,0l7.24-7.24A22.32,22.32,0,0,1,47.13,81.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-mod",
    d: "M83.57,49.29l8-8a1.51,1.51,0,0,0,0-2.12,1.49,1.49,0,0,0-2.12,0L81.5,47.13A23.41,23.41,0,0,1,83.57,49.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-mod",
    d: "M81.5,82.87l7.94,7.94a1.49,1.49,0,0,0,1.06.44,1.53,1.53,0,0,0,1.06-.44,1.51,1.51,0,0,0,0-2.12l-8-8A22.32,22.32,0,0,1,81.5,82.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-mod",
    d: "M49.3,46.43l-7.24-7.24a1.5,1.5,0,0,0-2.12,2.12l7.19,7.19A22.32,22.32,0,0,1,49.3,46.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-mod",
    d: "M64.25,89.32V100a1.5,1.5,0,0,0,3,0V89.23c-.74.07-1.49.11-2.25.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-mod",
    d: "M67.25,40.77V30a1.5,1.5,0,0,0-3,0V40.68l.75,0C65.76,40.66,66.51,40.7,67.25,40.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-mod",
    d: "M43.19,54,34,50.22A1.5,1.5,0,1,0,32.84,53L42,56.8c.17-.47.34-.93.53-1.4S43,54.48,43.19,54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-mod",
    d: "M98.66,77,88.07,72.62c-.16.47-.33.94-.53,1.41s-.4.92-.62,1.36l10.59,4.39A1.5,1.5,0,0,0,98.66,77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-mod",
    d: "M42.23,73.12,32.84,77A1.5,1.5,0,0,0,34,79.78l9.45-3.92A24.77,24.77,0,0,1,42.23,73.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-mod",
    d: "M88.23,57.31,98.66,53a1.5,1.5,0,0,0-1.15-2.77l-10.37,4.3A24.81,24.81,0,0,1,88.23,57.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-mod",
    d: "M73.46,87.54l4.3,10.37a1.5,1.5,0,0,0,.81.81,1.48,1.48,0,0,0,1.15,0,1.51,1.51,0,0,0,.81-2L76.21,86.33A24.93,24.93,0,0,1,73.46,87.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-mod",
    d: "M57.66,41.54l-3.92-9.45A1.5,1.5,0,1,0,51,33.24l3.89,9.39A25,25,0,0,1,57.66,41.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-mod",
    d: "M55.06,86.9,51,96.76a1.5,1.5,0,0,0,2.77,1.15l4.12-10c-.71-.22-1.42-.47-2.12-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-mod",
    d: "M76.41,43.19l4.12-9.95a1.51,1.51,0,0,0-.81-2,1.49,1.49,0,0,0-2,.81L73.67,42c.23.09.47.17.7.27Q75.42,42.67,76.41,43.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-exposure-mod",
    d: "M85.87,63.5a20.89,20.89,0,0,0-4.7-11.8,22.42,22.42,0,0,0-2.09-2.16A20.78,20.78,0,0,0,65,44.06l-.75,0A20.88,20.88,0,0,0,51.7,48.83a22.42,22.42,0,0,0-2.16,2.09A20.84,20.84,0,0,0,44.13,63.5c0,.5-.07,1-.07,1.5s0,1,.07,1.5a20.84,20.84,0,0,0,5.41,12.58,22.42,22.42,0,0,0,2.16,2.09,20.88,20.88,0,0,0,12.55,4.74c.25,0,.5,0,.75,0a20.78,20.78,0,0,0,14.08-5.48,22.42,22.42,0,0,0,2.09-2.16,20.89,20.89,0,0,0,4.7-11.8c0-.5.07-1,.07-1.5S85.9,64,85.87,63.5Zm-3,3A17.85,17.85,0,0,1,79,76.16,18.54,18.54,0,0,1,77,78.34a17.87,17.87,0,0,1-9.71,4.45,18.62,18.62,0,0,1-2.25.15c-.25,0-.5,0-.75,0A17.85,17.85,0,0,1,53.84,79,18.54,18.54,0,0,1,51.66,77,17.87,17.87,0,0,1,47.13,66.5c0-.5-.07-1-.07-1.5s0-1,.07-1.5A17.87,17.87,0,0,1,51.66,53,18.54,18.54,0,0,1,53.84,51a17.85,17.85,0,0,1,10.41-3.88l.75,0a18.62,18.62,0,0,1,2.25.15A17.87,17.87,0,0,1,77,51.66,18.54,18.54,0,0,1,79,53.84a17.85,17.85,0,0,1,3.84,9.66c0,.5.07,1,.07,1.5S82.91,66,82.87,66.5Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExposureModerate);
export default __webpack_public_path__ + "static/media/exposure-moderate.2b21d68f.svg";
export { ForwardRef as ReactComponent };